const ReportFormInputWithLabel = ({
  label,
  name,
  value = '',
  defaultValue = '',
  onChange,
  show = true,
  type = 'text',
  placeholder = '',
  inputClassName = '',
  minWidth = '120px',
  startLabel = '',
  endLabel = ''
}) => {
  return (
    <div className='d-flex align-items-center my-2'>
      <label className='fw-bold me-2' style={{fontSize: '18px', minWidth}}>
        {label}
      </label>
      {startLabel && (
        <span className='fw-normal ms-2' style={{fontSize: '18px'}}>
          {startLabel}
        </span>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        className={`${inputClassName} ${show ? 'd-block' : 'd-none'} createTime`}
        style={{
          border: '1px solid #ddd',
          outline: 'none',
          padding: '10px',
          marginLeft: '10px',
          width: '100%'
        }}
      />
      {endLabel && (
        <span className='fw-normal ms-2' style={{fontSize: '18px'}}>
          {endLabel}
        </span>
      )}
    </div>
  );
};

export default ReportFormInputWithLabel;
